///
/// EarthBrowser
///
/// Created by Matt Giger on 9/24/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Mounts a floating properties window for every open image ground
/// overlay ("image" dataset windows created by drag-drop, cloud opens,
/// dataset shares, or story playback).
///

import { ImageOverlayBrowserRenderer } from "@/components/features/image-overlay-browser/ImageOverlayBrowser"
import { useAppSelector } from "@/redux/store"

export function ImageOverlayBrowserFeature() {
	const datasetWindows = useAppSelector(state => state.dialog.datasetWindows)
	const imageWindows = Object.values(datasetWindows).filter(w => w.windowType === "image")

	if (imageWindows.length === 0) {
		return null
	}

	return (
		<>
			{imageWindows.map(windowState => (
				<ImageOverlayBrowserRenderer
					key={windowState.id}
					windowId={windowState.id}
					windowState={windowState}
				/>
			))}
		</>
	)
}
